"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Star, Sparkles } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AustinsMobileSpaOnWheels() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="240186" id="garden-grown-elegance" className="relative w-full min-h-[80vh] flex items-center py-20 md:py-32 lg:py-40 overflow-hidden bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675409/img/petal_garden_sunrise.png)]">
      {}
      <div className="absolute inset-0 bg-black/40 z-0" />

      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-10 pointer-events-none">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] rounded-lg bg-secondary/20 blur-3xl" />
        <div className="absolute top-[60%] -right-[10%] w-[40%] h-[60%] rounded-lg bg-accent/10 blur-3xl" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-20">
        <div ref={textRef} className={`flex flex-col items-start space-y-8 transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-accent/90 text-accent-foreground text-sm font-medium mb-2 backdrop-blur-sm">
            <Sparkles className="size-4" />
            <span className="font-default">Cultivated in Our Garden</span>
          </div>
          
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-default font-bold text-white leading-tight tracking-tight max-w-4xl">
            Artistry Rooted <br className="hidden md:block" />
            <span className="relative inline-block mt-2">
              in Earth
            </span>
          </h1>

          <p className="text-lg md:text-xl text-white/90 max-w-[600px] leading-relaxed font-default">
            Experience the serene beauty of PETAL. We blend modern boutique design with seasonal blooms harvested directly from our family-owned garden.
          </p>

          <div className="pt-4 flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
            <div className="relative inline-flex group">
              <div className="absolute inset-0 rounded-md bg-white animate-ping opacity-10 group-hover:opacity-20 transition-opacity duration-300"></div>
              <Link to="/ShopPage" className="relative z-10 w-full sm:w-auto">
                <Button size="lg" variant="default" className="w-full sm:w-auto text-base h-14 px-8 shadow-lg bg-white text-primary font-serif rounded-md hover:bg-white/90">
                  Shop the Collection
                </Button>
              </Link>
            </div>
            
            <Link to="/TheGardenPage" className="w-full sm:w-auto">
              <Button size="lg" variant="outline" className="w-full sm:w-auto text-base h-14 px-8 bg-white/10 backdrop-blur-md border-white/30 text-white font-default rounded-md hover:bg-white/20">
                Explore the Garden
              </Button>
            </Link>
          </div>
          
          <div className="flex items-center gap-4 pt-6 border-t border-white/20 w-full max-w-md">
            <div className="flex -space-x-3">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675409/img/customer_portrait_1.png" alt="Floral enthusiast" className="w-10 h-10 rounded-md border-2 border-white/20 object-cover" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675409/img/customer_portrait_2.png" alt="Event planner" className="w-10 h-10 rounded-md border-2 border-white/20 object-cover" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675409/img/customer_portrait_3.png" alt="Local resident" className="w-10 h-10 rounded-md border-2 border-white/20 object-cover" />
            </div>
            <div className="flex flex-col">
              <div className="flex items-center gap-1 text-secondary">
                <Star className="size-4 fill-current" />
                <Star className="size-4 fill-current" />
                <Star className="size-4 fill-current" />
                <Star className="size-4 fill-current" />
                <Star className="size-4 fill-current" />
              </div>
              <span className="text-sm text-white/70 font-medium font-default">Trusted for 1,000+ local events</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}